// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "com.binance",
    name: "Binance Web3 Wallet",
    homepage: "https://www.binance.com/en/web3wallet",
    image_id: "ebac7b39-688c-41e3-7912-a4fefba74600",
    app: {
        browser: "https://www.binance.com/en/web3wallet",
        ios: "https://www.binance.com/en/download",
        android: "https://www.binance.com/en/download",
        mac: "",
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "bnc://app.binance.com/cedefi/",
        universal: "https://app.binance.com/cedefi",
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map